// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__14QhX","option":"styles_option__3FNMh","active":"styles_active__1Ai_R"};